<template>

    <div>
        <div class="row">
            <div :class="columnclass">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">{{ lang.get("documents.addedbyme") }}</h2>
                        <div class="box-tools">
                            <router-link
                                class="btn btn-primary btn-xs"
                                :to="{name:'documents.add.index'}"
                                v-tooltip.bottom="'Document toevoegen'"
                            >
                                <i class="mdi mdi-plus"></i>
                                <span class="sr-only">Document toevoegen</span>
                            </router-link>
                        </div>
                    </div>
                    <div class="box-body no-padding">
                        <table class="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>{{ lang.get("documents.filename") }}</th>
                                    <th>{{ lang.get('global.created_at') }}</th>
                                    <th>{{ lang.get("documents.size") }}</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody v-if="!isLoading">
                                <tr v-show="pendingdocuments.user && pendingdocuments.user.length === 0">
                                    <td colspan="4">{{ lang.get("documents.noaddedfilesbyme") }}</td>
                                </tr>
                                <tr v-for="doc in pendingdocuments.user">
                                    <td>{{ doc.name }}</td>
                                    <td>{{ doc.date }}</td>
                                    <td>{{ doc.size | formatBytes }}</td>
                                    <td class="text-right">
                                        <button class="btn btn-primary btn-xs" @click="open(doc)" v-tooltip="'Document openen'"><i class="fa fa-eye"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="overlay" v-show="isLoading">
                        <i class="fa fa-refresh fa-spin"></i>
                    </div>
                </div>
            </div>
            <div :class="columnclass" v-for="map in getScanDirectories">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">Scan map: {{ map }}</h2>
                    </div>
                    <div class="box-body no-padding">
                        <table class="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>{{ lang.get("documents.filename") }}</th>
                                    <th>{{ lang.get('global.created_at') }}</th>
                                    <th>{{ lang.get("documents.size") }}</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-show="pendingdocuments[map].length === 0">
                                    <td colspan="4">{{ lang.get("documents.nonewfiles") }}</td>
                                </tr>
                                <tr v-for="doc in pendingdocuments[map]">
                                    <td>{{ doc.name }}</td>
                                    <td>{{ doc.date }}</td>
                                    <td>{{ doc.size | formatBytes }}</td>
                                    <td class="text-right">
                                        <button class="btn btn-primary btn-xs"
                                            @click="open(doc)"
                                            v-tooltip="'Document openen'"
                                        ><i class="fa fa-eye"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="overlay" v-show="isLoading">
                        <i class="fa fa-refresh fa-spin"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="processDocumentModal" tabindex="-1" role="dialog">
            <div :class="{'modal-dialog':true, 'modal-xl':canShowPreview && templates.length > 0}" role="document">
                <div class="modal-content" v-if="templates.length > 0">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">{{ lang.get("documents.process.header") }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="selectedDocument !== null">
                            <div :class="{'col-sm-3':canShowPreview, 'col-sm-12':!canShowPreview}">
                                <div class="form-group">
                                    <label class="control-label">Naam:</label>
                                    <p class="form-control-static" v-text="selectedDocument.name"></p>
                                </div>
                                <div class="form-group">
                                    <label class="control-label">{{ lang.get("documents.process.template") }}:</label>
                                    <select name="template_uuid" class="form-control"
                                        v-model="postdata.template_uuid"
                                    >
                                        <option value="">- {{ lang.get("global.select") }} -</option>
                                        <option
                                            v-for="template in templates"
                                            :value="template.uuid"
                                        >{{ template.name }}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label class="control-label">{{ lang.get("documents.process.subject") }}:</label>
                                    <input type="text" class="form-control" tabindex="1" v-model="postdata.subject" />
                                </div>
                                <div class="form-group">
                                    <label>{{ lang.get('documents.connections.header') }}</label>
                                    <table class="table table-striped">
                                        <tbody>
                                            <tr v-if="connections.length === 0">
                                                <td colspan="2">{{ lang.get('documents.connections.noconnections') }}</td>
                                            </tr>
                                            <tr v-for="conn in connections">
                                                <td>{{ lang.get('documents.connections.types.' + conn.connection) }}: {{ conn.name }}</td>
                                                <td class="text-right">
                                                    <button @click="removeConnection(conn)" class="btn btn-danger btn-xs" v-tooltip="lang.get('documents.connections.deleteconnection')"><i class="fa fa-times"></i></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="2" class="text-right">
                                                    <button class="btn btn-info btn-xs" @click="openDocumentsConnector" type="button" v-tooltip="lang.get('documents.connections.addconnection')"><i class="fa fa-plus"></i></button>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div class="form-group">
                                    <label>Notificatie versturen naar collega's</label>
                                    <table class="table table-striped">
                                        <tbody>
                                            <tr v-if="postdata.users.length === 0">
                                                <td colspan="2">Er zijn geen collega's geselecteerd</td>
                                            </tr>
                                            <tr v-if="postdata.users.length > 0" v-for="uuid in postdata.users">
                                                <td>{{ getOfficeUsers.filter(user => user.uuid === uuid)[0].fullname }}</td>
                                                <td class="text-right">
                                                    <button @click="removeTeamMember(uuid)" class="btn btn-danger btn-xs"><i class="fa fa-times"></i></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="2" class="text-right">
                                                    <button class="btn btn-info btn-xs" @click="openOfficeSearch()" type="button" v-tooltip="'Collega toevoegen'"><i class="fa fa-plus"></i></button>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <delete-button
                                                v-if="selectedDocument.paths.deleteuri"
                                                title="Document"
                                                :url="selectedDocument.paths.deleteuri"
                                                :name="selectedDocument.name"
                                                @delete-completed="deletedDocument"
                                                v-tooltip="'Document verwijderen'"
                                            ></delete-button>
                                        </div>
                                        <div class="col-sm-6 text-right">
                                            <button @click="fire()" type="button" class="btn btn-sm btn-primary" :disabled="!canSubmit && !posting">{{ lang.get("global.save") }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-9 text-center" v-if="canShowPreview">
                                <img v-if="selectedDocumentIsImage" :src="selectedDocument.paths.previewuri" style="max-width:100%;height:auto;" />
                                <vue-p-d-f-viewer
                                    height="800px"
                                    :url="selectedDocument.paths.previewuri"
                                    style="width:100%;"
                                ></vue-p-d-f-viewer>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-content" v-else>
                    <div class="modal-header">
                        <h4 class="modal-title">{{ lang.get("documents.process.notemplateerror.header") }}</h4>
                    </div>
                    <div class="modal-body">
                        <p>{{ lang.get("documents.process.notemplateerror.content") }}</p>
                    </div>
                </div>
            </div>
        </div>
        <documents-connections
            ref="documentsConnections"
            @add-connection="addConnection"
        ></documents-connections>
        <office-selector
            ref="pendingOfficeSelector"
            @selected-users="setSelectedUsers"
        ></office-selector>
    </div>

</template>

<script>

import {mapGetters,mapActions} from 'vuex';
import axios from 'axios';
import Lang from '../../Lang';
import CrmSelector from '../Common/Selectors/CrmSelector';
import vSelect from 'vue-select';
import OfficeSelector from "../Common/Selectors/OfficeSelector";
import DocumentsConnections from "./Connections";
import VuePDFViewer from 'vue-instant-pdf-viewer';

export default {

    components:{
        DocumentsConnections,
        OfficeSelector,
        CrmSelector,
        vSelect,
        VuePDFViewer,
    },

    computed:{

        ...mapGetters([
            "dataLoaded",
            "getOfficeUsers",
            "isLoading",
        ]),

        canShowPreview(){
            return this.selectedDocumentIsImage === true ||
                (this.selectedDocument !== null &&
                    this.selectedDocument.mimetype === 'application/pdf');
        },

        canSubmit() {
            let data = this.getPostdata;
            if (data.template_uuid === null || data.template_uuid === "") {
                return false;
            }
            if (this.getSelectedTemplate.requires_subject && data.subject === "") {
                return false;
            }
            return data.connections.length > 0;
        },

        getScanDirectories(){
            let dirs = [];
            for (let te in this.pendingdocuments) {
                if (te !== 'user' && this.pendingdocuments.hasOwnProperty(te)) {
                    dirs.push(te);
                }
            }
            return dirs;
        },

        getSelectedTemplate() {
            let template = this.templates.filter(tp => tp.uuid === this.postdata.template_uuid);
            // check length
            if (template.length === 0) {
                return null;
            }
            return template[0];
        },

        getPostdata() {
            let data = this.postdata;
            if (this.selectedDocument !== null) {
                data.document_uuid = this.selectedDocument.uuid;
            }
            data.connections = this.connections;
            return data;
        },

        selectedDocumentIsImage() {
            if (null === this.selectedDocument) {
                return false;
            }

            return this.selectedDocument.mimetype === 'image/png' ||
                this.selectedDocument.mimetype === 'image/jpeg';
        },

    },

    data(){
        return {
            columnclass:'col-sm-12',
            connections:[],
            lang:Lang,
            pendingdocuments:[],
            postdata:{
                subject:'',
                template_uuid:'',
                users:[],
            },
            posting:false,
            selectedDocument:null,
            templates:[],
        }
    },

    methods:{

        ...mapActions([
            "parseData",
            "setLoading",
        ]),

        addConnection(connection) {
            if (this.connections.filter(conn => conn.id === connection.id).length === 0) {
                this.connections.push(connection);
            }
        },

        close() {
            $('#processDocumentModal').modal('hide');
            this.resetData();
        },

        closeOfficeSearch() {
            this.$refs.pendingOfficeSelector.closeOfficeSearch();
        },

        deletedDocument() {
            this.posting = true;
            let docid = this.getPostdata.document_uuid;
            this.removeDocument(docid);
            this.close();
            this.$snotify.success("Het document is verwijderd");
        },

        fire() {
            if (!this.canSubmit) {
                return false;
            }
            this.posting = true;
            let docid = this.getPostdata.document_uuid;
            // Make a post request
            axios.post(this.route('api.v1.documents.storepending'), this.getPostdata)
            .then(() => {
                this.removeDocument(docid);
                this.$snotify.success("Het document is opgeslagen");
                this.close();
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden bij het opslaan van het document"))
            .finally(() => this.posting = false);
        },

        getPendingDocuments(){
            axios.get(this.documentsUri)
            .then(response => {
                this.pendingdocuments = response.data.data;
                this.setColumnClass();
                this.setLoading(false);
            });
        },

        open(document) {
            this.resetData();
            this.selectedDocument = document;
            if (typeof this.$refs.embedBoxPreview !== 'undefined') {
                this.$refs.embedBoxPreview.src = document.paths.previewuri;
            }
            $('#processDocumentModal').modal('show');
        },

        openDocumentsConnector() {
            this.$refs.documentsConnections.open();
        },

        openOfficeSearch() {
            this.$refs.pendingOfficeSelector.openOfficeSearch();
        },

        removeConnection(connection) {
            this.connections.splice(this.connections.findIndex(conn => conn.uuid === connection.uuid), 1);
        },

        removeDocument(docid) {
            this.pendingdocuments.user.splice(this.pendingdocuments.user.findIndex((usr) => usr.uuid === docid), 1);
            // Remove the item from the overview
            for (let map in this.getScanDirectories) {
                if (this.getScanDirectories.hasOwnProperty(map)) {
                    this.pendingdocuments[this.getScanDirectories[map]].splice(this.pendingdocuments[this.getScanDirectories[map]].findIndex((usr) => usr.uuid === docid), 1);
                }
            }
        },

        removeTeamMember(uuid) {
            this.postdata.users.splice(this.postdata.users.findIndex(usr => usr === uuid), 1);
        },

        resetData(){
            this.selectedDocument = null;
            this.postdata = {
                subject:'',
                template_uuid:'',
                users:[],
            };
            this.connections = [];
            this.posting = false;
        },

        setColumnClass(){
            let columns = this.getScanDirectories.length + 1;
            if (columns >= 3) {
                this.columnclass = 'col-sm-4';
            } else {
                if (columns === 2) {
                    this.columnclass = 'col-sm-6';
                }
            }
        },

        setSelectedUsers(users) {
            this.postdata.users = users;
        },

        checkTemplates() {
            if (this.templates.length === 0) {
                this.getTemplates();
            }
        },

        getTemplates() {
            axios.get(this.route('api.v1.templates.list'), {params:{upload:true, module:'documents'}})
                .then(response => this.templates = response.data.data);
        },

    },

    mounted(){
        window.PDFObject = PDFObject;
        this.getPendingDocuments();
        this.parseData();
        this.checkTemplates();
    },

    name:"DocumentsPending",

    props:{
        documentsUri: {
            required:true,
        },
    },

}

</script>
